import React from "react";
import styled from "styled-components";

export default function FullButton({ title, action, border }) {
  return (
    <Wrapper
      onClick={action}
      onKeyDown={action ? (event) => event.key === "Enter" && action() : undefined}
      role={action ? "button" : undefined}
      tabIndex={action ? 0 : undefined}
      $border={border}
    >
      <span>{title}</span>
      <span aria-hidden="true">↗</span>
    </Wrapper>
  );
}

const Wrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 100%;
  min-height: 52px;
  padding: 14px 22px;
  border: 1px solid ${({ $border }) => ($border ? "#d7dbd9" : "#0a9250")};
  border-radius: 999px;
  background: ${({ $border }) => ($border ? "#fff" : "#0a9250")};
  color: ${({ $border }) => ($border ? "#17152f" : "#fff")};
  font-size: 0.88rem;
  font-weight: 800;
  cursor: pointer;
  box-shadow: ${({ $border }) => ($border ? "none" : "0 14px 30px rgba(10, 146, 80, .22)")};
  transition: 0.25s ease;
  span:last-child { transition: transform 0.25s ease; }
  &:hover {
    color: ${({ $border }) => ($border ? "#0a9250" : "#fff")};
    border-color: #0a9250;
    transform: translateY(-2px);
    box-shadow: 0 18px 34px rgba(23, 21, 47, 0.14);
  }
  &:hover span:last-child { transform: translate(2px, -2px); }
`;
